import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRemoteClientPost } from '../../../configs/http-client'
import { CatchMessageError } from '../../../remote/catch-message-error'
import { useLocalStorage } from '../../../remote/local-storage'
import { ComboSelectWithLabel } from '../../components/combo-select-with-label'
import { Label } from '../../components/ui/label'
import { formatCPF } from '../../utils/formatDocuments'
import SellTab from '../member/sell/sell-tab'
import { Endpoints } from '@/remote/endpoints'

export function ReceptionQuickSell() {
  const [params] = useSearchParams()
  const { httpClientPost } = useRemoteClientPost()
  const [loading, setLoading] = useState(false)
  const { getUnitId } = useLocalStorage()
  const [dataClients, setDataClients] = useState<any>([])

  const [clientSelected, setClientSelected] = useState('')

  useEffect(() => {
    if (!loading) {
      setLoading(true)
      httpClientPost(`${Endpoints.client}/filtro?page=${0}&size=${1000}&order=desc&sort=id`, {
              idUnidade: [params.get('id') ?? getUnitId()],
              status: 1,
            })
        .then((response: any) => {
          setDataClients(
            response.data.data.content.map((item: any) => ({
              ...item,
              label: `${item.nome} - ${formatCPF(item.cpf)}`,
              value: item.id.toString()
            }))
          )
        })
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }, [params])

  return (
    <div className="w-full">
      <div className="mb-4">
        <Label>Cliente</Label>
        <ComboSelectWithLabel defaultValue={clientSelected} data={dataClients} onChange={(e) => setClientSelected(e.value)} className="w-full" />
      </div>
      <SellTab externalMemberSelected={clientSelected} sellType="VENDA_RAPIDA" />
    </div>
  )
}
